
export function getImageUrl(path) {
    return `${process.env.PUBLIC_URL}/${path}`;
}